export default "__VITE_ASSET__BzUm8u2i__"